import httpClient from "../httpClient";
import { API_USER_UPDATE } from "../config";

const updateUserInfo = {
  updateInfo: (id, data) => httpClient.post(API_USER_UPDATE + '/' + id, data),
};

export default updateUserInfo;
